/* v2.1 - phone fix apr3 */
// Cache bust: 2026-03-26T17:05:25.656650

// === ATTRIBUTION CAPTURE (runs on every page this JS loads) ===
(function(){
  var p = new URLSearchParams(window.location.search);
  var prefix = 'inergize_';
  ['gclid','gbraid','wbraid','fbclid'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  if(!localStorage.getItem(prefix + 'landing_page')){
    localStorage.setItem(prefix + 'landing_page', window.location.href);
    localStorage.setItem(prefix + 'referrer', document.referrer || '');
    localStorage.setItem(prefix + 'first_touch_ts', new Date().toISOString());
  }
  localStorage.setItem(prefix + 'latest_touch_ts', new Date().toISOString());
})();
// === END ATTRIBUTION CAPTURE ===

/**
 * Brochure Lead Capture JavaScript
 * Handles modal interactions and GHL form submission
 */

(function() {
  'use strict';

  // Ensure functions are only defined once
  if (window.brochureModalFunctions) {
    return;
  }
  window.brochureModalFunctions = true;

  // Zapier Configuration
  const ZAPIER_CONFIG = {
    webhookUrl: 'https://hooks.zapier.com/hooks/catch/10623553/upjot7h/',
  };

  // Modal functions
  function openBrochureModal() {
    const modal = document.getElementById('brochure-modal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      // Populate UTM fields from URL params
      populateUTMFields();
      
      // Track modal open event
      if (typeof gtag === 'function') {
        gtag('event', 'brochure_modal_open', {
          event_category: 'lead_capture',
          event_label: 'buyers_guide'
        });
      }
    }
  }

  function closeBrochureModal() {
    const modal = document.getElementById('brochure-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  // Populate UTM fields from URL parameters
  function populateUTMFields() {
    const urlParams = new URLSearchParams(window.location.search);
    
    // Set UTM fields with defaults
    document.getElementById('utm_source').value = urlParams.get('utm_source') || 'inergize';
    document.getElementById('utm_medium').value = urlParams.get('utm_medium') || 'brochure';
    document.getElementById('utm_campaign').value = urlParams.get('utm_campaign') || 'buyers-guide-2026';
    document.getElementById('sca_ref').value = urlParams.get('sca_ref') || '';
    document.getElementById('sca_source').value = urlParams.get('sca_source') || '';
    document.getElementById('page_url').value = window.location.href;
    document.getElementById('referrer').value = document.referrer || '';
    
    // OFFLINE CONVERSION TRACKING: Capture click IDs for conversion tracking
    const gclid = urlParams.get('gclid') || getStoredGclid() || '';
    const fbclid = urlParams.get('fbclid') || getStoredFbclid() || '';
    const gbraid = urlParams.get('gbraid') || localStorage.getItem('inergize_gbraid') || sessionStorage.getItem('inergize_gbraid') || '';
    const wbraid = urlParams.get('wbraid') || localStorage.getItem('inergize_wbraid') || sessionStorage.getItem('inergize_wbraid') || '';

    // Store click IDs in cookies with 90-day expiry
    if (gclid) setCookie('gclid', gclid, 90);
    if (fbclid) setCookie('fbclid', fbclid, 90);
    if (gbraid) setCookie('gbraid', gbraid, 90);
    if (wbraid) setCookie('wbraid', wbraid, 90);

    // Set hidden fields
    if (document.getElementById('gclid')) document.getElementById('gclid').value = gclid;
    if (document.getElementById('fbclid')) document.getElementById('fbclid').value = fbclid;
    if (document.getElementById('gbraid')) document.getElementById('gbraid').value = gbraid;
    if (document.getElementById('wbraid')) document.getElementById('wbraid').value = wbraid;
  }

  // Cookie management functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return '';
  }

  // Helper functions to get stored click IDs (check localStorage first, then sessionStorage, then cookies)
  function getStoredGclid() {
    return localStorage.getItem('inergize_gclid') || sessionStorage.getItem('inergize_gclid') || getCookie('gclid') || '';
  }

  function getStoredFbclid() {
    return localStorage.getItem('inergize_fbclid') || sessionStorage.getItem('inergize_fbclid') || getCookie('fbclid') || '';
  }

  // Submit lead to Zapier webhook
  async function submitToZapier(formData) {
    const payload = {
      // Core contact info
      firstName: formData.firstName || '',
      lastName: formData.lastName || '',
      email: formData.email || '',
      phone: `${formData.countryCode}${formData.phone}`.replace(/\D/g, ''), // Clean phone number
      
      // Form-specific fields
      productInterest: formData.productInterest || '',
      useCase: formData.useCase || '',
      budget: formData.budget || '',
      timeline: formData.timeline || '',
      describes: formData.describes || '',
      
      // Tracking data
      source: 'Brochure Lead Capture',
      utm_source: formData.utm_source || 'inergize',
      utm_medium: formData.utm_medium || 'brochure',
      utm_campaign: formData.utm_campaign || 'buyers-guide-2026',
      page_url: formData.page_url || '',
      referrer: formData.referrer || '',
      sca_ref: formData.sca_ref || '',
      sca_source: formData.sca_source || '',
      
      // Offline conversion tracking data
      gclid: getStoredGclid() || formData.gclid || '',
      fbclid: getStoredFbclid() || formData.fbclid || '',
      gbraid: localStorage.getItem('inergize_gbraid') || sessionStorage.getItem('inergize_gbraid') || formData.gbraid || '',
      wbraid: localStorage.getItem('inergize_wbraid') || sessionStorage.getItem('inergize_wbraid') || formData.wbraid || '',
      
      // Metadata
      submittedAt: new Date().toISOString(),
      formVersion: 'v2-p2-brochure'
    };

    console.log('Submitting to Zapier:', payload);

    try {
      const response = await fetch(ZAPIER_CONFIG.webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Zapier Webhook Error: ${response.status}`);
      }

      const result = await response.text(); // Zapier usually returns text, not JSON
      console.log('Zapier Success:', result);
      return result;

    } catch (error) {
      console.error('Zapier Submission Error:', error);
      throw error;
    }
  }

  // Form submission handler
  function initializeForm() {
    const form = document.getElementById('brochure-lead-form');
    if (!form) return;

    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const data = Object.fromEntries(formData.entries());
      
      // Get submit button elements
      const submitBtn = document.getElementById('brochure-submit');
      const originalText = submitBtn.textContent;
      
      // Show loading state
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      
      // Track form submission attempt
      if (typeof gtag === 'function') {
        gtag('event', 'brochure_form_submit', {
          event_category: 'lead_capture',
          event_label: 'buyers_guide',
          product_interest: data.productInterest || 'not_specified',
          budget: data.budget || 'not_specified',
          timeline: data.timeline || 'not_specified',
          describes: data.describes || 'not_specified'
        });
      }

      try {
        // Submit to Zapier
        // Submit to our worker for GHL + attribution + notifications
      try {
        await fetch('https://inergize-api.inergize.workers.dev/brochure', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data)
        });
      } catch(e) { console.error('Worker submit error:', e); }
      // Also submit to Zapier as backup
      // Submit to worker for GHL + attribution + notifications
      try { await fetch('https://inergize-api.inergize.workers.dev/brochure', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) }); } catch(e) {}
      await submitToZapier(data);
        
        // Success state
        showSuccessState();
        
        // Track successful submission - GA4
        if (typeof gtag === 'function') {
          gtag('event', 'generate_lead', {
            currency: 'USD',
            value: 0,
            product_interest: data.productInterest,
            budget: data.budget,
            timeline: data.timeline
          });
        }
        
        // Google Ads Lead conversion
        if (typeof gtag === 'function') {
          gtag('event', 'conversion', {
            'send_to': 'AW-10843887244/v2ggCMfTlY0cEIyt4rIo',
            'value': 0,
            'currency': 'USD'
          });
        }
        
        // Fire Meta Pixel
        if (typeof fbq === 'function') {
          fbq('track', 'Lead', {
            content_name: 'Buyers Guide',
            content_category: 'brochure',
            value: 0,
            currency: 'USD'
          });
        }
        
        // Klaviyo - Track Brochure Download event
        if (typeof _learnq !== 'undefined') {
          _learnq.push(['identify', {
            '$email': data.email,
            '$first_name': data.firstName,
            '$last_name': data.lastName,
            '$phone_number': data.phone
          }]);
          _learnq.push(['track', 'Brochure Download', {
            'Product Interest': data.productInterest,
            'Budget': data.budget,
            'Timeline': data.timeline,
            'Use Case': data.useCase,
            'Source': 'PDP Brochure CTA'
          }]);
        }
        
        // Trigger PDF download then redirect to thank-you page
        setTimeout(() => {
          triggerBrochureDownload();
          // Redirect to thank-you page after brief delay for download to start
          setTimeout(() => {
            window.location.href = '/pages/thank-you-buyers-guide';
          }, 1500);
        }, 1000);
        
      } catch (error) {
        console.error('Form submission error:', error);
        
        // Error state
        submitBtn.textContent = 'Error - Please Try Again';
        setTimeout(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }, 3000);
        
        // Track error
        if (typeof gtag === 'function') {
          gtag('event', 'brochure_form_error', {
            event_category: 'lead_capture',
            event_label: 'buyers_guide',
            error_message: error.message
          });
        }
        
        alert('Something went wrong. Please try again or contact support.');
      }
    });
  }

  // Show success state
  function showSuccessState() {
    const form = document.getElementById('brochure-lead-form');
    const successDiv = document.getElementById('brochure-success');
    
    if (form && successDiv) {
      form.style.display = 'none';
      successDiv.style.display = 'block';
    }
  }

  // Trigger brochure download
  function triggerBrochureDownload() {
    // Placeholder URL - replace with actual brochure PDF
    const brochureUrl = '/pages/cold-plunge-buyers-guide-download'; // Shopify page for now
    
    // Create download link
    const downloadLink = document.createElement('a');
    downloadLink.href = brochureUrl;
    downloadLink.target = '_blank';
    downloadLink.rel = 'noopener noreferrer';
    downloadLink.click();
  }

  // Reset form to initial state
  function resetForm() {
    const form = document.getElementById('brochure-lead-form');
    const successDiv = document.getElementById('brochure-success');
    const submitBtn = document.getElementById('brochure-submit');
    
    if (form) {
      form.reset();
      form.style.display = 'block';
    }
    if (successDiv) {
      successDiv.style.display = 'none';
    }
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Download Free Guide';
    }
  }

  // Phone number formatting - (555) 123-4567
  function formatPhoneNumber(input) {
  var digits = input.value.replace(/\D/g, '').substring(0, 10);
  var formatted = '';
  if (digits.length > 0) formatted = '(' + digits.substring(0, 3);
  if (digits.length >= 3) formatted += ') ' + digits.substring(3, 6);
  if (digits.length >= 6) formatted += '-' + digits.substring(6, 10);
  input.value = formatted;
}

// Initialize phone formatting
  function initializePhoneFormatting() {
    var phoneInput = document.getElementById('brochure-phone') || document.getElementById('phone');
    if (phoneInput) {
      phoneInput.addEventListener('input', function() {
        formatPhoneNumber(this);
      });
    }
  }

  // Keyboard shortcuts
  function initializeKeyboardShortcuts() {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeBrochureModal();
      }
    });
  }

  // Click outside to close
  function initializeClickOutside() {
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('brochure-modal-backdrop')) {
        closeBrochureModal();
      }
    });
  }

  // Intersection Observer for analytics
  function initializeViewTracking() {
    const ctaCard = document.querySelector('.brochure-cta-card');
    if (!ctaCard) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && typeof gtag === 'function') {
          gtag('event', 'brochure_cta_view', {
            event_category: 'lead_capture',
            event_label: 'buyers_guide'
          });
          observer.unobserve(ctaCard); // Only track once
        }
      });
    }, { threshold: 0.5 });

    observer.observe(ctaCard);
  }

  // Initialize everything when DOM is ready
  function initialize() {
    initializeForm();
    initializePhoneFormatting();
    initializeKeyboardShortcuts();
    initializeClickOutside();
    initializeViewTracking();
  }

  // Make functions globally available
  window.openBrochureModal = openBrochureModal;
  window.closeBrochureModal = closeBrochureModal;
  window.resetBrochureForm = resetForm;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();